module.exports = __webpack_public_path__ + "img/adjust.e9bae773.svg";